import { SwiftWindFunnelIds } from '../../enums/swiftWindFunnelIds';
import { StateRestricted } from '../../enums/stateRestricted';

export const funnelIdsThatIgnoreBundlesAltogether = ['3283', '2813', '3470', '3572', '3573', '3721', '3761', '3762', '3763', '3766'];
export const funnelIdsThatIgnoreDefaultBundles = ['3485', ...Object.values(SwiftWindFunnelIds)];

export const stateSpecificRestrictedFunnels: Record<StateRestricted, string[]> = {
	[StateRestricted.AmmunitionShipping]: ['2797', '2798', '2799', '2800', '3310', '3311', '3312', '3313']
};
